<template>
    <!-- BundleItem -->
    <div class="item" :class="{ 'item-selected' : hasProductInCart(bundle.GearProduct.GearGlobalProductId) && bundle.DiscountPercentage > 0, 'item-cadex' : bundle.GearProduct.BrandId == 4 }">
        <div class="text">
            <img src="https://static.giant-bicycles.com/Images/Cadex/Logos/Cadex-Logo-New.png" v-if="bundle.GearProduct.BrandId == 4" class="brandlogo" />
            <p class="slogan" v-if="bundle.GearProduct.BrandId == 4">
                {{getInterfaceText('cadex_slogan')}}
            </p>
            <h5>
                {{ bundle.GearProduct.Name }}
            </h5>
            <h4>{{ bundle.PriceMinToFormat }} <span v-show="bundle.PriceMin != bundle.PriceMax">- {{ bundle.PriceMaxToFormat }}</span> <span class="oldprice" style="margin-left:10px;" v-show="bundle.DiscountPercentage > 0">{{bundle.Partnumbers[0].priceOriginalToFormat}}</span></h4>
            <select class="form-control" v-model="selectedBundle" :disabled="hasProductInCart(bundle.GearProduct.GearGlobalProductId) && bundle.Type == 0 && bundle.DiscountPercentage > 0" v-show="bundle.Partnumbers.length > 1" v-on:change="bundleSelectOnChange()">
                <!--v-show="(selectedPartnumber == null && bundle.Partnumbers.length > 1) || bundle.DiscountPercentage == 0"-->
                <option selected="selected" value="">{{bundle.Partnumbers[0].descriptionTypeLabel}}</option>
                <option v-for="partnumber in bundle.Partnumbers" :key="partnumber.code" :value="partnumber" :disabled="partnumber.stock.Code == 0 || (hasPartnumberInCart(partnumber.code) && bundle.Type == 1)">{{partnumber.descriptionIncludingStockLabel}}</option>
            </select>
            <button class="btn btn-add" v-if="selectedBundle && selectedBundle.stock != null && selectedBundle.stock.Code > 0" v-show="hasProductInCart(bundle.GearProduct.GearGlobalProductId) == false || bundle.Type != 0 || bundle.DiscountPercentage == 0" v-on:click="addCartItem(selectedBundle.code, bundle.GearLocalProductId, 2, bundle.GearProduct, selectedBundle, callbackSuccess, callbackException)">{{getInterfaceText('add_to_cart')}}</button>
            <div class="added" v-show="selectedPartnumber != null && bundle.Type == 0 && (bundle.DiscountPercentage > 0 || showAddedLabel)">
                <span class="added-text">
                    <i class="icongiant-check" aria-hidden="true"></i> {{getInterfaceText('shop_added_to_cart')}}
                </span>
                <button class="btn btn-remove" v-show="bundle.DiscountPercentage > 0" v-on:click="removePartnumberFromCart(selectedPartnumber.code)" title="Remove from cart"><i class="glyphicon glyphicon-trash"></i></button>
            </div>
            <div class="alert alert-danger" style="margin-top:10px;" v-show="exceptionMessageBundleItem != undefined && exceptionMessageBundleItem.length > 0">{{exceptionMessageBundleItem}}</div>
        </div>
        <div class="image">
           <a v-if="bundle.GearProduct.Image != null && bundle.GearProduct.Image.length > 0" :href="url" :target="bundle.GearProduct.BrandId == 4 ? '_blank' : '_self'">
                <div class="imageframe"><img :src="bundle.GearProduct.Image" /></div>
                <span v-if="bundle.GearProduct.BrandId == 4" class="learnmore">{{getInterfaceText('link_learn_more')}}</span>
            </a>
        </div>
        <p class="discount-text" v-show="bundle.Partnumbers[0].DiscountPercentage > 0">{{getInterfaceText('shop_bundle_free_of_charge_description')}}</p>
    </div>
</template>
<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'BundleItem',
        props: ['bundle', 'parentProduct'],
        mixins: [cartMixin, generalMixin],
        data: function () {
            return {
                selectedBundle: '',
                showAddedLabel: false,
                exceptionMessageBundleItem: ''
            }
        },
        methods: {
            callbackSuccess() {
                this.showAddedLabel = true;
                var that = this;
                setTimeout(function () {
                    that.showAddedLabel = false;
                }, 10000);
            },
            callbackException(msg) {
                this.exceptionMessageBundleItem = msg;
                var that = this;
                setTimeout(function () {
                    that.exceptionMessageBundleItem = '';
                }, 10000);
            },
            bundleSelectOnChange() {
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_bundle', 'ga4_model_category': this.parentProduct.GA_Category, 'ga4_model_name': this.parentProduct.Product.Name, 'ga4_click_text': this.selectedBundle.description });
            },
            trackCrossLink() {
                var clickText = this.getInterfaceText('link_learn_more');
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'cross_promotion', 'ga4_model_name': this.bundle.GearProduct.Name, 'ga4_click_text': clickText });
            }
        },
        computed: {
            selectedPartnumber() {
                for (var i = 0; i < this.bundle.Partnumbers.length; i++) {
                    if (this.hasPartnumberInCart(this.bundle.Partnumbers[i].code)) {
                        return this.bundle.Partnumbers[i];
                    }
                }
                return null;
            },
            url() {
                return (this.bundle.GearProduct.ShowCadex ? 'https://www.cadex-cycling.com/' : '/') + window.culture + '/' + this.bundle.GearProduct.UrlLabel;
            }
        },
        mounted() {
            if (this.selectedPartnumber != null) {
                this.selectedBundle = this.selectedPartnumber;
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);

            //set default indien 1 option
            if (this.bundle != null && this.bundle.Partnumbers != null && this.bundle.Partnumbers.length == 1) {
                this.selectedBundle = this.bundle.Partnumbers[0];
            }
        }
    }
</script>
